import {ErrorBoundary} from "commons";
import React, {Suspense} from "react";
import {Loader} from "../common/Loader";
import { DataManagement } from "components/datamanagement/DataManagement";


export const DataManagementView = () => {
    return (<div className="mx-3 mb-5">
        <ErrorBoundary>
            <Suspense fallback={<div className="d-flex justify-content-center">
                <Loader/>
            </div>}>
                <DataManagement/>
            </Suspense>
        </ErrorBoundary>
    </div>)
}